import { useNavigate } from 'react-router-dom';

import { Button } from '@/components/shadcn/ui/button';

export function SharedLinkUnavailable() {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate('/');
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-white">
      <div className="flex w-full max-w-sm flex-col items-center px-6">
        <div
          style={{ width: 24, height: 24, cursor: 'pointer' }}
          onClick={() => navigate('/')}
        >
          <img
            src="/assets/logo-rebranding-syncly.svg"
            width="100%"
            height="100%"
            alt="Syncly"
          />
        </div>

        <h1 className="mt-6 text-2xl font-semibold text-gray-900">
          This link is unavailable
        </h1>

        <p className="mt-2 text-center text-gray-500">
          The link may have expired or not found.
        </p>

        <Button variant="outline" className="mt-6" onClick={handleGoBack}>
          Go back to the workspace
        </Button>
      </div>
    </div>
  );
}
